/**
 * Purchase-options picker inside Horizon's product form (snippets/clnf-purchase-options.liquid):
 * retail Subscribe & Save, or B2B plans when the root has data-b2b-plans.
 * Shows the fieldset for the selected variant and sets selling_plan only when a plan is chosen.
 * B2B also writes the clnf-b2b-subscriptions line properties; company buyers
 * (data-b2b-one-time-line="true") always send selling_plan="" because B2B checkout rejects plans.
 */
(function () {
  'use strict';

  if (window.__clnfRetailPlans) return;
  window.__clnfRetailPlans = true;

  function setNamed(input, name, value) {
    input.value = value;
    if (value) input.setAttribute('name', name);
    else input.removeAttribute('name');
  }

  function sync(root) {
    var form = root.closest('form');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var variantId = idInput ? String(idInput.value) : '';
    var fieldsets = root.querySelectorAll('.subscription-plans-fieldset');
    var visible = null;

    for (var i = 0; i < fieldsets.length; i++) {
      var match = String(fieldsets[i].getAttribute('data-variant-id')) === variantId;
      fieldsets[i].classList.toggle('subscription-plans-by-customer--hidden', !match);
      if (match) visible = fieldsets[i];
    }

    var isB2b = root.hasAttribute('data-b2b-plans');
    root.classList.toggle('subscription-plans-by-customer--hidden', !visible);

    var hidden = root.querySelector('[data-selling-plan-input]');
    if (!hidden) return;

    var checked = visible ? visible.querySelector('input[type="radio"]:checked') : null;
    var planId = checked ? checked.getAttribute('data-selling-plan-id') || '' : '';

    if (!isB2b) {
      setNamed(hidden, 'selling_plan', planId);
      return;
    }

    var oneTimeLine = root.getAttribute('data-b2b-one-time-line') === 'true';
    hidden.value = oneTimeLine ? '' : planId;
    hidden.setAttribute('name', 'selling_plan');

    var values = {
      label: planId ? checked.getAttribute('data-plan-label') || '' : '',
      plan: planId,
      auto: planId ? 'true' : '',
    };
    var props = root.querySelectorAll('[data-b2b-prop]');
    for (var p = 0; p < props.length; p++) {
      setNamed(props[p], props[p].getAttribute('data-prop-name'), values[props[p].getAttribute('data-b2b-prop')] || '');
    }
  }

  function boot() {
    var roots = document.querySelectorAll('.subscription-plans-by-customer');
    for (var i = 0; i < roots.length; i++) sync(roots[i]);
  }

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var root = target.closest('.subscription-plans-by-customer');
      if (!root && target.name === 'id') {
        var form = target.closest('product-form-component');
        root = form && form.querySelector('.subscription-plans-by-customer');
      }
      if (root) sync(root);
    },
    true
  );

  document.addEventListener('variant:update', boot);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
